export default __webpack_public_path__ + "static/media/TD35_1.5b28376a.jpg";